import { createBrowserRouter } from 'react-router-dom';

////////////////////////////////////////////////////////////// client

import App from './App';
import Find from './routes/Auth/Find/Find';
import SignIn from './routes/Auth/SignIn';
import SignUp from './routes/Auth/SignUp/SignUp';
import Welcome from './routes/Auth/Welcome';
import Home from './routes/Home/Home';
import Me from './routes/Me/Me';

////////////////////////////////////////////////////////////// admin

import Admin from './routes/Admin/Admin';
import Analysis from './routes/Admin/Analysis/Searching';
import Companies from './routes/Admin/Company/Companies';
import Ingredients from './routes/Admin/Ingredient/Ingredients';
import KeywordsByKeyword from './routes/Admin/Keyword/KeywordsByKeyword';
import KeywordsByMedicine from './routes/Admin/Keyword/KeywordsByMedicine';
import LogIn from './routes/Admin/LogIn';
import Main from './routes/Admin/Main';
import Medicines from './routes/Admin/Medicine/Medicines';
import MeiliSearch from './routes/Admin/MeiliSearch/MeiliSearch';
import Pharmacies from './routes/Admin/Pharmacy/Pharmacies';
import SearchLogs from './routes/Admin/Analysis/SearchLogs';
import ChangePassword from './routes/Me/ChangePassword';
import Quit from './routes/Me/Quit';
import Medicine from './routes/Medicine/Medicine';
import Search from './routes/Search/Search';
import Guests from './routes/Admin/Users/Guests';
import ErrorElement from './routes/ErrorElement';
import Chat from './routes/Chat/Chat';
import ChatDetail from './routes/Chat/Detail/ChatDetail';
import Profile from './routes/Chat/Profile/Profile';
import Likes from './routes/Chat/Profile/My/Likes';
import My from './routes/Chat/Profile/My/My';
import AdminChats from './routes/Admin/Chats/Chats';
import AdminComments from './routes/Admin/Chats/Comments';
import AdminReplies from './routes/Admin/Chats/Replies';
import AdminProfiles from './routes/Admin/Chats/Profiles';
import Feed from './routes/Chat/Feed/Feed';
import Users from './routes/Admin/Users/Users';
import Searching from './routes/Admin/Analysis/Searching';
import Chatting from './routes/Admin/Analysis/Chatting';
import Entry from './routes/Admin/Analysis/Entry';
import EntryLogs from './routes/Admin/Analysis/EntryLogs';
import Trend from './routes/Admin/Analysis/Trend';

////////////////////////////////////////////////////////////// router

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <ErrorElement />,
        children: [

            // 로그인 되지 않은 사용자를 위한 라우트들 (Layout 미적용)

            // client

            {
                path: '',
                element: <Welcome />,
            },
            {
                path: 'signin',
                element: <SignIn />,
            },
            {
                path: 'signup',
                element: <SignUp />,
            },
            {
                path: 'find',
                element: <Find />,
            },
            
            //////////////////////////////////////////////////////////////
            //////////////////////////////////////////////////////////////


            // 로그인 된 사용자를 위한 라우트들 (Layout 적용)

            // client

            {
                path: 'home',
                element: <Home />,
            },
            {
                path: 'search',
                element: <Search />,
            },
            {
                path: 'me',
                element: <Me />,
            },
            {
                path: 'changepassword',
                element: <ChangePassword />,
            },
            {
                path: 'quit',
                element: <Quit />,
            },
            {
                path: 'medicine/:medicineId',
                element: <Medicine />,
            },
            {
                path: 'chat',
                element: <Chat />,
                children: [
                    {
                        path: '',
                        element: <Feed />,
                    },
                    {
                        path: ':slug',
                        element: <ChatDetail />,
                    },
                    {
                        path: 'profile/:nickname',
                        element: <Profile />,
                    },
                    {
                        path: 'profile/my',
                        element: <My />,
                    },
                    {
                        path: 'profile/my/likes',
                        element: <Likes />,
                    },

            ]},
        ],
    },

    //////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////

    // admin

    {
        path: '/admin',
        element: <Admin />,
        errorElement: <ErrorElement />,
        children: [
            {
                path: '',
                element: <LogIn />,
            },
            {
                path: 'main',
                element: <Main />,
            },
            {
                path: 'analysis',
                children: [
                    {
                        path: 'search',
                        element: <Searching />,
                    },
                    {
                        path: 'search-logs',
                        element: <SearchLogs />,
                    },
                    {
                        path: 'entry',
                        element: <Entry />,
                    },
                    {
                        path: 'entry-logs',
                        element: <EntryLogs />,
                    },
                    {
                        path: 'chat',
                        element: <Chatting />,
                    },
                    {
                        path: 'trend',
                        element: <Trend />,
                    },
                ],
            },
            {
                path: 'users',
                element: <Users />,
            },
            {
                path: 'guests',
                element: <Guests />,
            },
            {
                path: 'profiles',
                element: <AdminProfiles />,
            },
            {
                path: 'chats',
                element: <AdminChats />,
            },
            {
                path: 'comments',
                element: <AdminComments />,
            },
            {
                path: 'replies',
                element: <AdminReplies />,
            },
            {
                path: 'pharmacies',
                element: <Pharmacies />,
            },
            {
                path: 'companies',
                element: <Companies />,
            },
            {
                path: 'medicines',
                element: <Medicines />,
            },
            {
                path: 'ingredients',
                element: <Ingredients />,
            },
            {
                path: 'meilisearch',
                element: <MeiliSearch />,
            },
            {
                path: 'keywords-by-keyword',
                element: <KeywordsByKeyword />,
            },
            {
                path: 'keywords-by-medicine',
                element: <KeywordsByMedicine />,
            },
            {
                path: 'companies',
                element: <Companies />,
            },
        ],
    },

    
    {
        path: '*',
        element: <ErrorElement />,
    }
]);
